<script setup lang="ts">
import {
  useRouterStore,
  useStatsigEventsStore,
} from '@apps/main/new-desktop/core/stores';

import { AppSvgIcon, AppRouterLink } from '@libs/ui';

const routerStore = useRouterStore();
const statsigEventsStore = useStatsigEventsStore();

interface AccommodationCardSelectedFooterProps {
  ingredientIndex: number;
  isMetaExperiment: boolean;
}
const props = defineProps<AccommodationCardSelectedFooterProps>();

function onNavigationTriggered(): void {
  statsigEventsStore.logTripOverviewExploreMoreHotelCardClicked();
}
</script>

<template>
  <AppRouterLink
    :link="
      routerStore.getHotelSelectionUrl({
        ingredientIndex: props.ingredientIndex,
      })
    "
    font="font-link-s-light"
    color="color-soft-black"
    wide
    @navigation-triggered="onNavigationTriggered"
  >
    <div
      class="accommodation-card-selected-footer"
      :class="{ 'meta-experiment': props.isMetaExperiment }"
    >
      <div v-if="!props.isMetaExperiment" class="information">
        <span>{{ $t('overview_accommodation_footer.not_right') }}</span>
        <div>
          <div class="link-wrapper">
            <AppSvgIcon name="lookingGlass" size="18" />
            <span class="link-text">
              {{ $t('overview_accommodation_footer.explore') }}
            </span>
          </div>
        </div>
      </div>
      <div v-if="!props.isMetaExperiment" class="label">
        {{ $t('planner.included') }}
      </div>
    </div>
  </AppRouterLink>
</template>

<style scoped lang="scss">
.accommodation-card-selected-footer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: var(--color-information-light);
  border-radius: var(--border-radius-8);
  padding: var(--spacing-8);
  gap: var(--spacing-4);

  &.meta-experiment {
    padding: 0;
    gap: 0;
    justify-content: flex-end;
  }

  .information {
    @include font-link-s-bold;
    color: var(--color-soft-black);
    display: flex;
    flex-direction: column;
    gap: var(--spacing-4);

    .link-wrapper {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: var(--spacing-4);
      .link-text {
        @include font-link-s-light;
        text-decoration: underline;
      }
    }
  }
  .label {
    @include font-label-s-light;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--color-white);
    padding: calc(var(--spacing-8) + var(--spacing-2)) var(--spacing-12);
    border-radius: var(--spacing-8);
    background-color: var(--color-brand-violet);
    height: fit-content;
  }
}
</style>
